import $ from 'jquery';
import {showFormResponse} from "../common/json-response";

export default function() {
  const removeButtons = document.querySelectorAll('.js-anyfile-variant-upload-remove');

  const removeFileItemHandler = function (e) {
    e.preventDefault();
    const statusWrapper = document.querySelector('.action-status-messages');
    const button = e.currentTarget;
    const url = button.getAttribute('data-url');

    $.ajax({
      type: "POST",
      url: url,
      dataType: 'json',
      success: function (data) {
        if (data.status === 'success') {
          const listItem = button.closest('.js-anyfile-upload-result-item');
          listItem?.remove();
        } else {
          showFormResponse(data);
        }
      },
      error: function (data) {
        if (data.messages) {
          showFormResponse(data);
        } else {
          const message = 'Возникла ошибка. Обратитесь пожалуйста в тех. поддержку';
          const statusMsg = document.createElement('div');
          statusMsg.classList.add(['alert']);
          statusMsg.classList.add(['alert_error']);
          statusMsg.innerHTML = message;
          statusWrapper.appendChild(statusMsg);
        }
      },
    });
  };

  removeButtons?.forEach(function (button) {
    button.addEventListener('click', removeFileItemHandler);
  });
}